<button
  mat-stroked-button
  [attr.type]="buttonType()"
  (click)="clickButton()"
  [attr.id]="buttonId()"
  [title]="ariaLabel() || label()"
  [attr.aria-label]="ariaLabel() || label()"
  [disabled]="isDisabled()"
  [color]="buttonStyle() === 'grey' ? undefined : buttonStyle()"
  [class.grey-button]="buttonStyle() === 'grey'"
  [class.negative-button]="buttonStyle() === 'negative'"
  [class.dark-blue-button]="buttonStyle() === 'dark-blue'"
  [class.selected-button]="buttonStyle() === 'selected'"
  [class.icon-right]="iconPosition() === 'right'"
  [class.disabled]="isDisabled()"
  class="button-text"
>
  @if (iconName()) {
    <mat-icon>{{ iconName() }}</mat-icon>
  }
  {{ label() }}
</button>
